module.exports = __webpack_public_path__ + "img/img_polaroid_quilt06@3x.2ad62de0.png";